import { ReactComponent as UnavailableSeatIcon } from '@eti/assets/icons/seating-buttons/default/seatButton-unavailable.svg';
import { css } from '@eti/styles';
import { Button } from '@etg/wings';
import { seatButtonStyles } from '../../utils/styles';
import { jsx as _jsx } from "react/jsx-runtime";
const unavailableSpanStyles = css`
  cursor: not-allowed;
  pointer-events: none;
`;
const UnavailableSeat = _ref => {
  let {
    seatTypeLabel
  } = _ref;
  return /*#__PURE__*/_jsx(Button, {
    "aria-label": seatTypeLabel,
    className: `${seatButtonStyles} ${unavailableSpanStyles}`,
    isDisabled: true,
    children: /*#__PURE__*/_jsx(UnavailableSeatIcon, {
      "aria-hidden": "true"
    })
  });
};
export default UnavailableSeat;
//# sourceMappingURL=UnavailableSeat.js.map